import { forwardRef } from 'react'

import { Polymorphic } from '../../../utils/PolymorphicUtils'

export const Background = forwardRef(function Background(
  { children, className, ...props },
  ref,
) {
  return (
    <div
      className={`relative overflow-hidden ${className ?? ''}`}
      {...props}
      ref={ref}
    >
      {children}
      <div
        className="pointer-events-none absolute inset-0 opacity-50 print:hidden"
        css={{
          backgroundImage:
            'linear-gradient(rgba(148, 163, 184, 0.2) 1px, transparent 1px), linear-gradient(90deg, rgba(148, 163, 184, 0.2) 1px, transparent 1px);',
          backgroundSize: '40px 40px',
          '.dark &': {
            backgroundImage:
              'linear-gradient(rgba(148, 163, 184, 0.15) 1px,transparent 1px), linear-gradient(90deg, rgba(148, 163, 184, 0.15) 1px, transparent 1px)',
          },
        }}
      />
      <div className="pointer-events-none absolute -top-48 right-0 h-96 w-96 rounded-full bg-neon-500/20 blur-[120px] print:hidden" />
      <div className="pointer-events-none absolute bottom-0 left-0 h-96 w-96 rounded-full bg-ember-500/20 blur-[160px] print:hidden" />
    </div>
  )
}) as Polymorphic<'div'>
